<template>
  <b-container
    fluid
    class="pr-0 pl-0">
    <b-navbar
      id="navbar"
      toggleable="md"
      type="dark"
      variant="dark">
      <b-container>
        <b-navbar-toggle target="nav_collapse"/>

        <b-navbar-brand :to="{ name: 'home', params: {} }">hiko.kiwi</b-navbar-brand>

        <b-collapse
          id="nav_collapse"
          is-nav>

          <!-- Main navigation links -->
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'home', params: {} }"
              exact>Menu</b-nav-item>
            <b-nav-item
              :to="{
                name: 'map',
                params: {
                  type: 'charging'
                }
              }"
              :active="mapNavActive"
            >Map</b-nav-item>
            <b-nav-item
              :to="{
                name: 'nearest'
              }"
            >Nearest</b-nav-item>
            <!-- <b-nav-item
              :to="{
                name: 'route'
              }"
            >Route</b-nav-item> -->
            <b-nav-item
              :to="{
                name: 'list'
              }"
            >List</b-nav-item>
            <b-nav-item
              :to="{
                name: 'recent'
              }"
            >Recent</b-nav-item>
            <!-- <b-nav-item
              :to="{
                name: 'admin'
              }"
            >Admin</b-nav-item> -->
            <b-nav-item
              :to="{
                name: 'info'
              }"
            >Help</b-nav-item>

        <!-- Map controls -->
        <!-- <b-navbar-nav
            v-if="mapNavActive"
            class="ml-auto">
            <b-nav-item-dropdown
              text="Map type">
              <MapTypeDropdown />
            </b-nav-item-dropdown>
          </b-navbar-nav> -->
        </b-navbar-nav></b-collapse>

      </b-container>
    </b-navbar>
  </b-container>
</template>

<script>

import MapTypeDropdown from './MapTypeDropdown.vue'

export default {
  name: 'NavBar',
  components: { MapTypeDropdown },
  computed: {
    mapNavActive: function () {
      if (this.$route.name === 'map') {
        return true
      }
    }
  }
}
</script>

<style scoped>

#navbar {
  z-index: +10;
}

.dropdown-menu {
  background-color: #343a40;
}

/* .dropdown {
  background-color: #343a40;
} */
</style>
